<template>
    <group-details :groupId="props.groupId">
        <div>
            <page-loading v-if="!billing"></page-loading>
            <template v-else>
                <group-proforma-invoices
                    v-if="billing.is_billable"
                    :teamId="props.teamId"
                    :groupId="props.groupId"
                    :paymentTermsDays="billing.payment_terms_days"
                />
            </template>
        </div>
    </group-details>
</template>

<script setup>
import GroupProformaInvoices from '~/components/settings/billing/GroupProformaInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import GroupDetails from '../form/GroupDetails.vue';
import { ref, onMounted, watch } from 'vue';
import { groupBillingClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const billing = ref(null);
const toasted = useToasted();

const getBillingDetails = async () => {
    try {
        const response = await groupBillingClient.getBillingDetails(props.teamId, props.groupId);
        billing.value = response.data;
    } catch (error) {
        console.error('Failed to fetch billing details:', error);
        toasted.error('Failed to load billing details. Please try again.');
    }
};

onMounted(() => {
    getBillingDetails();
});

watch(
    () => [props.teamId, props.groupId],
    () => {
        getBillingDetails();
    },
);
</script>
